import { createLocalizationFactory } from "@devowl-wp/react-frontend";
// Only needed once per `window`
let FACTORY_MEMO;
function get() {
    return FACTORY_MEMO ? FACTORY_MEMO : FACTORY_MEMO = createLocalizationFactory();
}
const useTranslation = (...args)=>get().useTranslation(...args);
export { useTranslation };
